import { render, staticRenderFns } from "./browseBox.vue?vue&type=template&id=2ad6b2e7&scoped=true"
import script from "./browseBox.vue?vue&type=script&lang=js"
export * from "./browseBox.vue?vue&type=script&lang=js"
import style0 from "./browseBox.vue?vue&type=style&index=0&id=2ad6b2e7&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6b2e7",
  null
  
)

export default component.exports